/*
 * @Author: cgh
 * @Date: 2022-08-01 10:43:48
 * @LastEditors: zxf
 * @LastEditTime: 2023-06-30 18:16:35
 * @Description: 消防安全评估管理
 */
/* =============================================
   业务功能路由配置文件引入start
  *
  *
*/

/* 业务功能路由配置文件引入 End */
// 评估项目
import pgxmRoutes from '@/features/xfaqpg/pgxm/pgxm.routes.js';

// 评估仪器
import pgyqRoutes from '@/features/xfaqpg/pgyqgl/pgyq.routes.js';

// 人员签到信息
import ryqdxxRoutes from '@/features/xfaqpg/ryqdxx/ryqdxx.routes.js';

// 问题列表管理
import wtlbRoutes from '@/features/xfaqpg/wtlb/wtlb.routes.js';

// 签章管理
import bgglRoutes from '@/features/xfaqpg/bggl/bggl.routes.js';

// 推送管理
import pgsjtsRoutes from '@/features/xfaqpg/bgts/pgsjts.routes.js';

/* =============================================
   业务功能路由配置写入 Start
  *
  *
*/
const FEATURES_ROUTES = [pgxmRoutes, pgyqRoutes, ryqdxxRoutes, wtlbRoutes, bgglRoutes, pgsjtsRoutes];

/* 业务功能路由配置写入 End */

// 路由配置=============================================
const xfaqpgRoutes = {
  path: 'xfaqpg',
  name: 'xfaqpg',
  component: { template: '<router-view></router-view>' },
  children: [
    ...FEATURES_ROUTES
  ]
};

export default xfaqpgRoutes;
